import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

//  引入需要的语言包
import en from "../locales/languages/en.js";
import fr from "../locales/languages/fr.js";
import de from "../locales/languages/de.js";
import ja from "../locales/languages/ja.js";
import zh from "../locales/languages/zh.js";

function normalizeLocale(value) {
  const normalized = String(value || "")
    .toLowerCase()
    .replace("_", "-");

  if (normalized.startsWith("fr")) return "fr";
  if (normalized.startsWith("de")) return "de";
  if (normalized.startsWith("ja")) return "ja";
  if (normalized.startsWith("zh")) return "zh-CN";
  return "en";
}

// 本地语言环境获取。浏览器通常返回 en-US/fr-FR 等区域标识，
// 需要归一化为语言包实际使用的 key。
const lang = normalizeLocale(
  localStorage.getItem("language") || navigator.language || "en"
);

const i18n = new VueI18n({
  locale: lang, // 语言标识
  fallbackLocale: "en", // 失败时默认语言
  silentTranslationWarn: true, // 设置为true 会屏蔽翻译在控制台报出的警告
  messages: {
    en: en,
    fr: fr,
    de: de,
    ja: ja,
    "zh-CN": zh,
  },
});

export default i18n;
